// src/AdminPanel/ManageShipping.js
import React, { useState, useEffect } from "react";
import { useShipping } from "../contexts/ShippingContext";
import toast from "../utils/toast";

function ManageShipping() {
  const { shippingCost, shippingLoading, saveShippingCost } = useShipping();
  const [costInput, setCostInput] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!shippingLoading) {
      setCostInput(shippingCost.toString());
    }
  }, [shippingLoading, shippingCost]);

  const handleSave = async (e) => {
    e.preventDefault();
    const parsedCost = parseInt(costInput, 10);
    
    if (isNaN(parsedCost) || parsedCost < 0) {
      toast.error("Please enter a valid shipping cost (0 or higher).");
      return;
    }
    
    setSaving(true);
    try {
      await saveShippingCost(parsedCost);
      toast.success("Shipping cost updated successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to save shipping cost.");
    } finally {
      setSaving(false);
    }
  };

  if (shippingLoading) {
    return (
      <div className="upload-page">
        <div className="upload-container">
          <p style={{ textAlign: "center", padding: "40px" }}>
            <i className="fa-solid fa-spinner fa-spin"></i> Loading...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="upload-page">
      <div className="upload-container">
        <h2>Manage Shipping Cost</h2>
        <p style={{ color: "#888", marginBottom: "24px", fontSize: "14px" }}>
          Configure the flat shipping rate applied to all orders during checkout.
        </p>

        <form className="upload-form" onSubmit={handleSave}>
          <div className="form-group">
            <label htmlFor="ms-cost">
              <i className="fa-solid fa-truck-fast" style={{ marginRight: "6px", color: "#d2222d" }}></i>
              Shipping Cost (Rs.)
            </label>
            <input
              id="ms-cost"
              type="number"
              min="0"
              value={costInput}
              onChange={(e) => setCostInput(e.target.value)}
              placeholder="e.g. 150"
              required
            />
          </div>

          <div style={{
            background: "#fff8e1",
            border: "1px solid #ffe082",
            borderRadius: "8px",
            padding: "14px 16px",
            marginBottom: "20px",
            fontSize: "13px",
            color: "#795548",
            lineHeight: "1.6",
          }}>
            <i className="fa-solid fa-circle-info" style={{ marginRight: "6px", color: "#f9a825" }}></i>
            <strong>Note:</strong> This shipping cost is added as a flat fee to all 'Cash on Delivery' orders. Setting it to 0 means Free Shipping.
          </div>

          <div className="form-submit-row save-sale-btn-outer-div">
            <button type="submit" disabled={saving || costInput === ""} className="save-sale-btn">
              {saving
                ? <><i className="fa-solid fa-spinner fa-spin"></i> Saving...</>
                : <><i className="fa-solid fa-floppy-disk"></i> Save Shipping Cost</>
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ManageShipping;
